import { render, staticRenderFns } from "./RadioFont.vue?vue&type=template&id=40d077d8&scoped=true&functional=true&"
import script from "./RadioFont.vue?vue&type=script&lang=js&"
export * from "./RadioFont.vue?vue&type=script&lang=js&"
import style0 from "./RadioFont.vue?vue&type=style&index=0&id=40d077d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "40d077d8",
  null
  
)

export default component.exports